export { default } from './RehabTreeList.component';
